import $ from 'jquery';
import {Easings, smoothy} from "smoothy";

function scrollToHash(hash) {
    if (hash === '') {
        return false;
    }
    let $target;
    if (hash === '#') {
        $target = $(document.body);
    } else {
        try {
            // special case for ibe-list
            if (hash === '#ibe-list' || hash === 'ibe-list') {
                $target = $('.lfm-ibe-banners')
                if ($target.length === 0) {
                    $target = $(hash);
                }
            } else {
                $target = $(hash);
            }
        } catch (e) {
            console.warn(e);
            return false;
        }
    }
    if ($target.length === 0) {
        return false;
    }
    let oldId = $target.attr('id');
    $target.removeAttr('id');
    smoothy(() => Math.max(0, $target.offset().top - 100), 1000, Easings.easeOutQuint).then(() => {
        $target.attr('id', oldId);
    });
    return true;
}

(function () {
    const hashStartsWith = (str) => {
        if (str.substring(0, 1) === '#') {
            str = str.substring(1);
        }
        return window.location.hash.startsWith(str)
            || window.location.hash.startsWith('#' + str);
    };

    if (window.location.hash) {
        if (hashStartsWith('#/de/oberharz/default/search/Event/')) {
            return;
        }
        scrollToHash(window.location.hash);
    }
})();

// links with .no-scroll are ignored. and within ibe-wrapper
$('a[href*="#"]:not(.no-scroll)').filter((i, e) => {
    return $(e).closest('.ibe-wrapper').length === 0;
}).on('click', function (e) {
    if (
        this.protocol === window.location.protocol
        && this.host === window.location.host
        && this.pathname === window.location.pathname
    ) {
        if (scrollToHash(this.hash)) {
            e.preventDefault();
        }
    }
});
